import {
  AccountPageDocument,
  UpsertLedgerAccountResourceDocument,
  UpsertLedgerAccountResourceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpsertLedgerBankAccountResource = () => {
  const [upsertAccountingBankAccountResource, { loading }] = useMutation(
    UpsertLedgerAccountResourceDocument,
    {
      extractorFn: (data) => data.financeMutations.upsertFinanceLedgerAccountResource,
      refetchQueries: [AccountPageDocument],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    upsertAccountingBankAccountResource: (
      variables: UpsertLedgerAccountResourceMutationVariables
    ) => upsertAccountingBankAccountResource({ variables }),
  }
}
